(function () {
  const DESKTOP_MQ = window.matchMedia('(min-width: 768px)');

  function syncReadMore(root) {
    const wrap = root.querySelector('[data-plp-hero-description]');
    const btn = root.querySelector('[data-plp-hero-toggle]');
    if (!wrap || !btn) return;

    const text = wrap.querySelector('.plp-hero__description');
    if (!text) return;

    if (DESKTOP_MQ.matches) {
      wrap.classList.remove('is-clamped');
      btn.hidden = true;
      btn.setAttribute('aria-expanded', 'true');
      return;
    }

    wrap.classList.add('is-clamped');
    btn.hidden = true;
    btn.textContent = btn.dataset.labelMore || 'MEHR LESEN';
    btn.setAttribute('aria-expanded', 'false');

    requestAnimationFrame(() => {
      if (DESKTOP_MQ.matches) return;

      const needsToggle = text.scrollHeight > text.clientHeight + 2;
      if (!needsToggle) {
        wrap.classList.remove('is-clamped');
        btn.hidden = true;
        return;
      }

      btn.hidden = false;
    });
  }

  function initReadMore(root) {
    const btn = root.querySelector('[data-plp-hero-toggle]');
    if (!btn) return;

    if (!root.dataset.plpHeroInit) {
      root.dataset.plpHeroInit = 'true';
      btn.addEventListener('click', () => {
        if (DESKTOP_MQ.matches) return;

        const wrap = root.querySelector('[data-plp-hero-description]');
        if (!wrap) return;

        const clamped = wrap.classList.toggle('is-clamped');
        btn.textContent = clamped
          ? btn.dataset.labelMore || 'MEHR LESEN'
          : btn.dataset.labelLess || 'WENIGER ANZEIGEN';
        btn.setAttribute('aria-expanded', clamped ? 'false' : 'true');
      });
    }

    syncReadMore(root);
  }

  function init() {
    document.querySelectorAll('[data-plp-hero]').forEach(initReadMore);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  DESKTOP_MQ.addEventListener('change', () => {
    document.querySelectorAll('[data-plp-hero]').forEach(syncReadMore);
  });

  document.addEventListener('shopify:section:load', (event) => {
    const hero = event.target.querySelector('[data-plp-hero]');
    if (hero) initReadMore(hero);
  });
})();
